"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectEditor = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var objectReducer_1 = require("../../reducers/objectReducer");
var valueToString_1 = __importDefault(require("../../utils/valueToString"));
var listWrapStyle = {
    width: '100%',
    flex: 1,
    border: 1,
    borderColor: 'grey.500',
    borderRadius: 1,
    boxSizing: 'border-box',
    overflow: 'auto',
    position: 'relative',
    minHeight: 100,
};
var listStyle = {
    position: 'absolute',
    width: '100%',
};
var listItemButtonStyle = {
    width: '100%',
};
var listItemTextStyle = {
    flexBasis: '50%',
};
var listItemTextTypographyStyle = {
    align: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};
function ObjectEditor(_a) {
    var value = _a.value, onChange = _a.onChange, onEdit = _a.onEdit, newItemKey = _a.newItemKey, newItemValue = _a.newItemValue;
    var _b = __read((0, react_1.useReducer)(objectReducer_1.objectReducer, value), 2), obj = _b[0], dispatch = _b[1];
    (0, react_1.useEffect)(function () {
        onChange(obj);
        // do not trigger an update when the change func is updated
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [obj]);
    (0, react_1.useEffect)(function () {
        dispatch({ action: objectReducer_1.ObjectActions.SET, value: value });
    }, [value]);
    var onAdd = function () {
        dispatch({
            action: objectReducer_1.ObjectActions.ADD_ITEM,
            key: newItemKey(obj),
            value: newItemValue(obj),
        });
    };
    return (react_1.default.createElement(material_1.Stack, { display: "flex", width: "100%", direction: "column", justifyContent: "flex-start", alignItems: "flex-start", spacing: 1, flex: 1 },
        react_1.default.createElement(material_1.Box, { sx: listWrapStyle },
            react_1.default.createElement(material_1.List, { dense: true, sx: listStyle }, Object.keys(obj).map(function (key) { return (react_1.default.createElement(material_1.ListItem, { key: key, disablePadding: true },
                react_1.default.createElement(material_1.ListItemButton, { sx: listItemButtonStyle, onClick: function () { return onEdit(key); } },
                    react_1.default.createElement(material_1.ListItemText, { sx: listItemTextStyle, primaryTypographyProps: listItemTextTypographyStyle, primary: key }),
                    react_1.default.createElement(material_1.ListItemText, { sx: listItemTextStyle, secondaryTypographyProps: listItemTextTypographyStyle, secondary: (0, valueToString_1.default)(obj[key]) })))); }))),
        react_1.default.createElement(material_1.Button, { endIcon: react_1.default.createElement(Add_1.default, null), color: "primary", variant: "outlined", fullWidth: true, onClick: onAdd }, "Add new")));
}
exports.ObjectEditor = ObjectEditor;
